var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMenuArchiveOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 5.33301V9.99967C13.3334 11.8853 13.3334 12.8281 12.7476 13.4139C12.1618 13.9997 11.219 13.9997 9.33342 13.9997H6.66675M2.66675 9.99967V5.33301",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2H2.99992C2.37684 2 2.06531 2 1.83325 2.13397C1.68123 2.22174 1.55499 2.34798 1.46723 2.5C1.33325 2.73205 1.33325 3.04359 1.33325 3.66667C1.33325 4.28975 1.33325 4.60128 1.46723 4.83333C1.55499 4.98535 1.68123 5.11159 1.83325 5.19936C2.06531 5.33333 6.87692 5.33333 7.5 5.33333M12.9999 5.33333C13.623 5.33333 13.9345 5.33333 14.1666 5.19936C14.3186 5.11159 14.4449 4.98535 14.5326 4.83333C14.6666 4.60128 14.6666 3.62308 14.6666 3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15L14 1",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9H9.66667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuArchiveOff);
export default __webpack_public_path__ + "static/media/group_menu_archive_off.abb85371c2839c8daca76080aed548b4.svg";
export { ForwardRef as ReactComponent };